import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const IncomingReportsTableRow = ({
  id, //={el.device_id}
  name, //={el.device_name}
  type, //={el.device_type}
  replyTn, //={el.reply_tn}
  outTotal, //={el.outTotal}
  inTotal, //={el.inTotal}
}) => (
  <TableRow key={'list' + id} id={id}>
    <TableCell name="id">{id}</TableCell>
    <TableCell name="name">{name}</TableCell>
    <TableCell name="type">{type}</TableCell>
    <TableCell name="replyTn">{replyTn}</TableCell>
    <TableCell name="outTotal">{outTotal}</TableCell>
    <TableCell name="inTotal">{inTotal}</TableCell>
  </TableRow>
);

export default IncomingReportsTableRow;
